const component = "select-program";

export const selectProgram = {
  component,
  skeleton: `${component}/skeleton`,
  noResultText: `${component}/no-result-text`,
  programSelectionCard: {
    card: `${component}/program-selection-card`,
    icon: `${component}/program-selection-card/icon`,
    programName: `${component}/program-selection-card/programName`,
    radioButton: `${component}/program-selection-card/radio-button`,
  },
};
